import { createIcon } from '@chakra-ui/icons';

export const Trash = createIcon({
  displayName: 'Trash',
  viewBox: '0 0 18 19',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
      <path
        d="M13.4741 7.75L13.1001 14.855C13.0441 15.917 12.1661 16.75 11.1031 16.75H6.8981C5.8341 16.75 4.9571 15.917 4.9011 14.855L4.5271 7.75"
        stroke="#E4626F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.75 5.25H15.25"
        stroke="#E4626F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75 5.25V3.25C6.75 2.698 7.198 2.25 7.75 2.25H10.25C10.802 2.25 11.25 2.698 11.25 3.25V5.25"
        stroke="#E4626F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>,
  ],
});
